export class DialogModelCollectSignedSlip {
    constructor(
      public invoiceData: any
    ) {}
  }